import { render, staticRenderFns } from "./ReferralSuccessPopup.vue?vue&type=template&id=0b9bb18a&"
import script from "./ReferralSuccessPopup.vue?vue&type=script&lang=js&"
export * from "./ReferralSuccessPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports